import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsGlobalPermissionsRoute: InvariantJiraRoute = {
	name: 'global-settings-global-permissions',
	path: '/secure/admin/global-permissions',
};
